











































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import moment from "moment";

@Component
export default class extends Mixins() {
  @Prop() total!: any;

  @Prop() is_today!: any;

  @Prop() submit!: any;

  @Prop() disabled!: any;

  get title() {
    return this.is_today ? "今日" : "总计";
  }

  fetchFailed() {
    this.fetch(2);
  }

  fetchCreating() {
    this.fetch(-1);
  }

  fetchSucceed() {
    this.fetch(1);
  }

  fetch(status: any) {
    switch (status) {
    }

    let fromAt = "";
    let toAt = "";
    if (this.is_today) {
      fromAt = moment().format("YYYY-MM-DD 00:00:00");
      toAt = moment().format("YYYY-MM-DD 23:59:59");
    }

    this.submit({
      page: 1,
      status,
      type: 0,
      from_at: fromAt,
      to_at: toAt
    });
  }
}
